import {
  EnrichmentModel,
  EnrichmentPreview,
  EnrichmentStatus,
  ModelSelectionData,
} from "types";
import {
  SET_SELECTED_MODEL_ID,
  SET_IS_PREVIEW_LOADING,
  SET_ENRICHMENT_CONTEXT_ID,
  SET_ENRICHMENT_MODEL_LIST,
  SET_PREVIOUS_DATASET_ENRICHMENT_MODELS,
  SET_ENRICHMENT_PREVIEW_DATA,
  SET_SHOW_ENRICHMENT_PROGRESS,
  SET_USER_SELECTED_PREVIEW_MODELS,
  SET_ENRICHED_DATASET_ID,
  SET_ENRICHMENT_PROGRESS,
  SET_ENRICHMENT_STATUS,
  SET_ENRICHED_TARGET_DATASET_ID,
  RESET_STORE,
  SET_MODEL_SELECTION_DATA,
  SET_MODEL_PROMPT,
} from "./constants";

const INITIAL_STATE: EnrichmentState = {
  modelList: [],
  previewData: [],
  userSelectedPreviewModels: [],
  previousDatasetEnrichmentModels: [],
  selectedModelId: null,
  isPreviewLoading: false,
  enrichmentContextId: null,
  showEnrichmentProgress: false,
  enrichmentProgress: 0,
  enrichmentStatus: null,
  enrichedDatasetId: null,
  enrichedTargetDatasetId: null,
  modelSelectionData: null,
};

const reducer = (state: EnrichmentState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_ENRICHMENT_MODEL_LIST:
      return { ...state, modelList: action.data };

    case SET_PREVIOUS_DATASET_ENRICHMENT_MODELS:
      return { ...state, previousDatasetEnrichmentModels: action.data };

    case SET_ENRICHMENT_CONTEXT_ID:
      return { ...state, enrichmentContextId: action.data };

    case SET_IS_PREVIEW_LOADING:
      return { ...state, isPreviewLoading: action.data };

    case SET_ENRICHMENT_PREVIEW_DATA:
      return { ...state, previewData: action.data };

    case SET_USER_SELECTED_PREVIEW_MODELS:
      return { ...state, userSelectedPreviewModels: action.data };

    case SET_ENRICHED_DATASET_ID:
      return { ...state, enrichedDatasetId: action.data };

    case SET_SHOW_ENRICHMENT_PROGRESS:
      return { ...state, showEnrichmentProgress: action.data };

    case SET_SELECTED_MODEL_ID:
      return { ...state, selectedModelId: action.data };

    case SET_ENRICHMENT_PROGRESS:
      return { ...state, enrichmentProgress: action.data };

    case SET_ENRICHMENT_STATUS:
      return { ...state, enrichmentStatus: action.data };

    case SET_ENRICHED_TARGET_DATASET_ID:
      return { ...state, enrichedTargetDatasetId: action.data };

    case SET_MODEL_SELECTION_DATA:
      return { ...state, modelSelectionData: action.data };

    case SET_MODEL_PROMPT:
      const selectedModel = state.userSelectedPreviewModels.find(
        (model) => model.id === action.data.modelId,
      );
      const metadata = {
        ...(selectedModel?.metadata || {}),
        prompt: action.data.prompt,
      };
      const userSelectedPreviewModels = state.userSelectedPreviewModels.map(
        (model) =>
          model.id === action.data.modelId ? { ...model, metadata } : model,
      );
      return { ...state, userSelectedPreviewModels };

    case RESET_STORE:
      const modelSelectionData = state.modelSelectionData;

      return { ...state, ...INITIAL_STATE, modelSelectionData };

    default:
      return state;
  }
};

export default reducer;

interface EnrichmentState {
  isPreviewLoading: boolean;
  modelList: EnrichmentModel[];
  previousDatasetEnrichmentModels: EnrichmentModel[];
  selectedModelId: string | null;
  previewData: EnrichmentPreview[];
  showEnrichmentProgress: boolean;
  enrichmentProgress: number;
  enrichmentStatus: null | EnrichmentStatus;
  userSelectedPreviewModels: EnrichmentModel[];
  enrichmentContextId: string | null;
  enrichedDatasetId: null | string;
  enrichedTargetDatasetId: null | string;
  modelSelectionData: ModelSelectionData | null;
}
